import { render, staticRenderFns } from "./uploadkelulusan.vue?vue&type=template&id=30fc4086&"
import script from "./uploadkelulusan.vue?vue&type=script&lang=js&"
export * from "./uploadkelulusan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports